module.exports = __webpack_public_path__ + "img/de.75a15c0b.svg";